// src/components/PDFDownloadButton.js
import React, { useState } from 'react';
import { Button, CircularProgress, Box, Snackbar, Alert } from '@mui/material';
import { PictureAsPdf, Download } from '@mui/icons-material';
import { PDFDownloadLink } from '@react-pdf/renderer';
import PerformanceReportPDF from './PerformanceReportPDF';

const PDFDownloadButton = ({ data, filters, disabled }) => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  if (!data || data.length === 0 || disabled) {
    return (
      <Button
        variant="contained"
        startIcon={<PictureAsPdf />}
        disabled
        sx={{
          backgroundColor: '#d32f2f',
          '&:hover': {
            backgroundColor: '#b71c1c',
          },
        }}
      >
        Generate PDF
      </Button>
    );
  }

  return (
    <>
      <PDFDownloadLink
        document={
          <PerformanceReportPDF 
            data={data} 
            filters={filters}
            reportDate={new Date()}
          />
        }
        fileName={`performance-report-${new Date().toISOString().split('T')[0]}.pdf`}
        onClick={() => {
          setSnackbarMessage('Generating PDF...');
          setSnackbarOpen(true);
        }}
      >
        {({ blob, url, loading, error }) => (
          <Button
            variant="contained"
            startIcon={loading ? <CircularProgress size={20} /> : <Download />}
            disabled={loading}
            sx={{
              backgroundColor: '#d32f2f',
              '&:hover': {
                backgroundColor: '#b71c1c',
              },
              minWidth: '150px',
            }}
          >
            {loading ? 'Generating...' : 'Download PDF'}
          </Button>
        )}
      </PDFDownloadLink>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <Alert onClose={handleSnackbarClose} severity="info" sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default PDFDownloadButton;